<template>
  <div class="text-center py-8">
    <div class="w-16 h-16 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
      <CheckCircleIcon class="w-8 h-8 text-green-600 dark:text-green-400" />
    </div>
    <h4 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">
      {{ t('app.subscription.renewal.payment_submitted') }}
    </h4>
    <p class="text-gray-600 dark:text-gray-400 mb-1">
      {{ t('app.subscription.renewal.pending_approval') }}
    </p>
    <p class="text-sm text-gray-500 dark:text-gray-500">
      {{ t('app.subscription.renewal.estimated_time') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { CheckCircleIcon } from '@heroicons/vue/24/outline'

const { t } = useI18n()
</script>
